__webpack_require__.p = "/Phone-catalog/";